<template>
    <section class="md-evaluation-banner evaluation-progress">
        <div class="md-evaluation-steps-content" :class="iconTheme">
            <template v-if="simpleMode">
                <div class="md-evaluation-steps">
                    <div class="steps-box">
                        <div class="step">
                            <span
                                class="step-icon iconfont icon-evaluation-step-1"
                                :class="{
                                    selected: step == 0
                                }"
                                :style="{
                                    color:
                                        step == 0 && iconTheme == 'default'
                                            ? stepIconColor
                                            : 'white',
                                    backgroundColor:
                                        step == 0 && iconTheme == 'classic'
                                            ? stepIconColor
                                            : ''
                                }"
                            ></span>
                        </div>
                        <div class="step-description">
                            <span class="step-label">{{
                                $t('md-evaluation-banner.step1')
                            }}</span>
                            <span>{{
                                $t('md-evaluation-banner.enterPropertyAddress')
                            }}</span>
                        </div>
                    </div>
                </div>
                <div class="md-evaluation-steps step-arrow">
                    <div class="steps-box">
                        <div class="step">
                            <span class="iconfont icon-next-big"> </span>
                        </div>
                    </div>
                </div>
                <div class="md-evaluation-steps">
                    <div class="steps-box">
                        <div class="step">
                            <span
                                class="step-icon iconfont icon-feature-1"
                                :class="{
                                    selected: step == 2
                                }"
                                :style="{
                                    color:
                                        step == 2 && iconTheme == 'default'
                                            ? stepIconColor
                                            : 'white',
                                    backgroundColor:
                                        step == 2 && iconTheme == 'classic'
                                            ? stepIconColor
                                            : ''
                                }"
                            ></span>
                        </div>
                        <div class="step-description">
                            <span class="step-label">{{
                                $t('md-evaluation-banner.step2')
                            }}</span>
                            <span>{{
                                $t('md-evaluation-banner.getPropertyEvaluation')
                            }}</span>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="md-evaluation-steps">
                    <div class="steps-box">
                        <div class="step">
                            <span
                                class="step-icon iconfont icon-evaluation-step-1"
                                :class="{
                                    selected: step == 0
                                }"
                                :style="{
                                    color:
                                        step == 0 && iconTheme == 'default'
                                            ? stepIconColor
                                            : 'white',
                                    backgroundColor:
                                        step == 0 && iconTheme == 'classic'
                                            ? stepIconColor
                                            : ''
                                }"
                            ></span>
                        </div>
                        <div class="step-description">
                            <span class="step-label">{{
                                $t('md-evaluation-banner.step1')
                            }}</span>
                            <span>{{
                                $t('md-evaluation-banner.enterPropertyAddress')
                            }}</span>
                        </div>
                    </div>
                </div>
                <div class="md-evaluation-steps" v-if="!isSkipStep2">
                    <div class="steps-box">
                        <div class="step">
                            <span
                                class="step-icon iconfont icon-evaluation-step-2"
                                :class="{
                                    selected: step == 1
                                }"
                                :style="{
                                    color:
                                        step == 1 && iconTheme == 'default'
                                            ? stepIconColor
                                            : 'white',
                                    backgroundColor:
                                        step == 1 && iconTheme == 'classic'
                                            ? stepIconColor
                                            : ''
                                }"
                            ></span>
                        </div>
                        <div class="step-description">
                            <span class="step-label">{{
                                $t('md-evaluation-banner.step2')
                            }}</span>
                            <span>{{
                                $t('md-evaluation-banner.propertyDetails')
                            }}</span>
                        </div>
                    </div>
                </div>
                <div class="md-evaluation-steps">
                    <div class="steps-box">
                        <div class="step">
                            <span
                                class="step-icon iconfont icon-evaluation-step-3"
                                :class="{
                                    selected: step == 2
                                }"
                                :style="{
                                    color:
                                        step == 2 && iconTheme == 'default'
                                            ? stepIconColor
                                            : 'white',
                                    backgroundColor:
                                        step == 2 && iconTheme == 'classic'
                                            ? stepIconColor
                                            : ''
                                }"
                            ></span>
                        </div>
                        <div class="step-description">
                            <span class="step-label">{{
                                !isSkipStep2
                                    ? $t('md-evaluation-banner.step3')
                                    : $t('md-evaluation-banner.step2')
                            }}</span>
                            <span>{{
                                $t('md-evaluation-banner.propertyValuation')
                            }}</span>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </section>
</template>

<script>
export default {
    i18next: {
        ns: 'md-evaluation-banner'
    },
    props: {
        step: {
            type: [Number, String],
            default: 0
        },
        iconTheme: {
            type: String,
            default: 'default'
        },
        simpleMode: {
            type: Boolean,
            default: false
        },
        stepIconColor: {
            type: String
        },
        // showCopyright: {
        //     type: Boolean
        // },
        isSkipStep2: {
            // This is used to determine whether to skip the second step
            type: Boolean,
            default: false
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-evaluation-banner.evaluation-progress {
    .md-evaluation-steps-content {
        display: flex;
        justify-content: space-around;
        padding: 50px 0 10px;
        .md-evaluation-steps {
            flex: 1;
            padding: 5px;
            .steps-box {
                color: #fff;
                font-size: 15px;
                font-family: var(--font-bold);
                line-height: 1.2;
                text-align: center;
                .step {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    .iconfont {
                        color: #fff;
                        font-size: 65px;
                        display: block;
                        font-style: normal;
                        font-weight: normal;
                        font-variant: normal;
                        text-transform: none;
                        line-height: 1;
                        &.icon-feature-1 {
                            font-size: 42px;
                            padding: 10px;
                        }
                        &.icon-next-big {
                            font-size: 18px;
                            width: 50px;
                            height: 50px;
                            border-radius: 50%;
                            box-shadow: 0 3px 5px 0 rgba(32, 36, 55, 0.2);
                            background-color: rgba(255, 255, 255, 0.4);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                    .selected {
                        color: var(--mg-button-background);
                    }
                }
                .step-description {
                    display: flex;
                    flex-direction: column;
                    text-align: center;
                }
            }
            &:nth-child(2) {
                border-left: solid 1px #ccc;
                border-right: solid 1px #ccc;
            }
            &.step-arrow {
                border: none;
                width: 60px;
                flex-grow: 0;
                align-self: center;
            }
        }

        &.classic {
            .md-evaluation-steps {
                .steps-box {
                    .step {
                        margin-bottom: 10px;
                        .step-icon {
                            font-size: 40px;
                            line-height: 52px;
                            &.icon-feature-1 {
                                padding: 0;
                                font-size: 26px;
                            }
                            &.selected {
                                display: inline-block;
                                width: 52px;
                                height: 52px;
                                text-align: center;
                                color: white;
                                @include color-button();
                                border-radius: 50%;
                            }
                        }
                    }
                }
                &:nth-child(2) {
                    border-left: none;
                    border-right: none;
                }
            }
        }
    }
    @include media-800 {
        .md-evaluation-steps-content {
            width: 100%;
            max-width: 100%;
            &.classic {
                .md-evaluation-steps {
                    .steps-box {
                        .step-description {
                            font-size: 13px;
                            .step-label {
                                padding-bottom: 5px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
